import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import moment from 'moment';
import { httpClient } from '@s20/services/httpClient';
import { FormContext } from '../../../common/forms/FormElements';
import { getMappedFilterModel, ServerSideScrollRowsRequest } from '../../../common/dataGrid/DataGrid';
import { ApiRoutes } from '../../../Common';

const defaultSelector = (response) => {
    const rows = response?.rows ?? [];

    return rows.map((job) => ({
        jobId: job.jobId ?? job.JobId,
        jobNumber: job.jobNumber ?? job.JobNumber,
        value: job.jobId ?? job.JobId,
        label: job.jobNumber ?? job.JobNumber,
        customer: job.customer ?? job.Customer,
        crewLead: job.crewLead ?? job.CrewLead,
        startTime: job.startTime ?? job.StartTime,
        requiredResources: job.requiredResources ?? job.RequiredResources,
        assignmentCount: job.assignmentCount ?? job.AssignmentCount,
        jobLocationAddress: job.jobLocationAddress ?? job.JobLocationAddress ?? job.jobLocation ?? job.JobLocation,
        latitude: job.latitude ?? job.Latitude,
        longitude: job.longitude ?? job.Longitude,
        meetingLatitude: job.meetingLatitude ?? job.MeetingLatitude,
        meetingLongitude: job.meetingLongitude ?? job.MeetingLongitude,
        meetingLocationAddress: job.meetingLocationAddress ?? job.MeetingLocationAddress,
        projectId: job.projectId ?? job.ProjectId,
        dispatchLocation: job.dispatchLocation ?? job.DispatchLocation,
    }));
};

export const useJobQuery = (selector = defaultSelector) => {
    const { values } = useContext(FormContext);
    const {
        dispatchOfficeLocationId,

        // Dispatch Plus Map
        selectedDate,
    } = values;

    const response = useQuery({
        queryKey: ['jobs', selectedDate, dispatchOfficeLocationId],
        queryFn: () => {
            const filterModel = {};

            if (dispatchOfficeLocationId) {
                filterModel.DispatchCompanyId = {
                    value: dispatchOfficeLocationId,
                };
            }

            if (selectedDate) {
                const mFrom = moment(selectedDate, 'YYYY-MM-DD');
                const mTo = mFrom.clone();

                filterModel.DateRange = {
                    dateFrom: mFrom.format('YYYY-MM-DD HH:mm:ss'),
                    dateTo: mTo.format('YYYY-MM-DD HH:mm:ss'),
                    filterType: 'date',
                    type: 'inRange',
                    key: 'DateRange',
                };
            }

            const filterModelMapped = getMappedFilterModel(
                { ...filterModel },
                {},
            );

            const req = new ServerSideScrollRowsRequest();
            req.startRow = 0;
            req.endRow = 5000;
            req.filterModel = { ...filterModelMapped };
            req.sortModel = [];

            return httpClient.post(
                ApiRoutes.job.dailyView(),
                req,
            );
        },
        select: selector,
    });

    return response;
};